var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["profile-ud-item sip-kv-item", _vm.colSpanClass] },
    [
      _c("div", { staticClass: "profile-ud" }, [
        _c("span", { staticClass: "profile-ud-label sip-kv-label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "profile-ud-value sip-kv-value" },
          [
            _vm.isEmptyValue
              ? [
                  _c("span", { staticClass: "profile-ud-empty sip-kv-empty" }, [
                    _vm._v("—"),
                  ]),
                ]
              : [
                  _vm.type === "date"
                    ? [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("moment")(_vm.value))),
                        ]),
                      ]
                    : _vm.type === "datetime"
                    ? [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("momentDateTime")(_vm.value))),
                        ]),
                      ]
                    : [
                        _vm.toUppercaseWord
                          ? _c("span", [_vm._v(_vm._s(_vm.ucword(_vm.value)))])
                          : _c("span", [_vm._v(_vm._s(_vm.value))]),
                      ],
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }